angular
	.module('empower.modules')
	.constant('jurisdictionClaimEnum', {
		NT: 5107058,
		VIC: 5108170,
		EPS: 5221826,
		TAS: 5255775,
		NSW: 5297968,
		SA: 5509070,
		WA: 5513934,
		CC: 5692238,
		QLD: 5965880,
	});